import React from 'react'

const LogInSplash = (props) => {
  const items = (props.msg && props.msg.items) ? props.msg.items : []
  const heading = items.length > 0 ? items[0].heading : ""
  const body = items.length > 0 ? items[0].body : ""

  return (
    <section className="container-fluid login_splash-wrap">
      <div className="row justify-content-center justify-content-md-end login_splash">
        <div className="col max-w-480px">
          <h1 className="login_heading">{heading}</h1>
          <div
            className="login_body"
            dangerouslySetInnerHTML={{ __html: body }}
          />
          <div className="text-right">
            <button
              type="button"
              className="login_splash-btn"
              onClick={props.toggleLogInFormVisible}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LogInSplash
